import createTheme from './createTheme'

export const base = {}

export default createTheme(base)
